import React from 'react'
import cl from 'classnames'
import { Props } from './types'
import { presets } from './presets'

const TableLineContainer = (props: Props) => {
  const {
    children,
    preset = 'primary',
    className,
    noBoxShadow
  } = props

  return (
    <div className={cl(presets[preset], className)}
      style={noBoxShadow ? { boxShadow: 'unset' } : {}}
    >
      {children}
    </div>
  )
}

export default TableLineContainer
